export default "__VITE_ASSET__CKl$s$Hg__"